/**
 * Stable CSS class names for E2E — User account follow-up grid.
 */
export const UAFP = {
    page: 'user-account-follow-paper-page',
    datagrid: 'user-account-follow-paper-page__datagrid',
} as const;

export const uafpCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
